<template>
	<main
		class="bg-e9ecef td-main-container w-100 position-relative"
		:class="{
			'td-main-container-loggedin': hasAccess(),
			padding20px: !hasAccess() && isLaptop,
		}"
	>
		<NcdTopContainer v-if="!isLaptop && hasAccess()" />

		<template>
			<div
				v-if="loaderStatus"
				class="td-main-whitecontainer h-100 w-100 d-flex justify-content-center align-items-center overflow-hidden"
				:class="{
					'td-main-whitecontainer-loggedin': hasAccess() && !isLaptop,
				}"
			>
				<Spinner />
			</div>
			<template v-else>
				<section
					class="td-main-whitecontainer h-100 w-100"
					:class="{
						'td-main-whitecontainer-loggedin': hasAccess() && !isLaptop,
						top75: !hasAccess() && !isLaptop,
					}"
				>
					<section
						class="td-main-bluecontainer w-100 d-flex mob-d-block"
						:style="{ height: isLaptop ? 'calc(100% - 60px)' : '100%' }"
					>
						<section class="w-70 mob-w-100">
							<h1
								class="fam-lato fs-30 fw-R text-darkgrey mob-fs-20 mob-fw-600"
							>
								Test Details
							</h1>

							<!-- Test Organizer -->
							<article class="mt-3">
								<div class="fam-lato fw-LM fs-12 color-3a3c40">
									Test Organizer
								</div>
								<template v-if="loading">
									<b-skeleton class="w-33 mt-1"></b-skeleton>
								</template>
								<div v-else class="fam-mont fw-M fs-14 color-3a3c40 pt-5px">
									{{ testOrganizerDisplay }}
								</div>
							</article>
							<hr style="border-top: 1px solid #c4c4c4; opacity: 30%" />
							<!-- Dates & Attempts -->
							<article class="">
								<b-row>
									<b-col :cols="isLaptop ? null : 6">
										<div class="fam-lato fw-LM fs-12 color-3a3c40">
											<img
												src="@/assets/img/Testdetails/dateicon.svg"
												class="mr-1"
												alt=""
											/>Start Date:
										</div>
										<template v-if="loading">
											<b-skeleton class="w-50 mt-1"></b-skeleton>
										</template>
										<div v-else class="fam-mont fw-M fs-14 color-3a3c40 pt-5px">
											{{ formatTime(assessment.config?.openTestdt) }},
											{{ formatDate(assessment.config?.openTestdt) }}
										</div>
									</b-col>
									<b-col :cols="isLaptop ? null : 6">
										<div class="fam-lato fw-LM fs-12 color-3a3c40">
											<img
												src="@/assets/img/Testdetails/dateicon.svg"
												class="mr-1"
												alt=""
											/>End Date:
										</div>
										<template v-if="loading">
											<b-skeleton class="w-50 mt-1"></b-skeleton>
										</template>
										<div v-else class="fam-mont fw-M fs-14 color-3a3c40 pt-5px">
											{{ formatTime(assessment.config?.closeTestdt) }},
											{{ formatDate(assessment.config?.closeTestdt) }}
										</div>
									</b-col>
									<b-col cols="6" id="hideinlaptop" class="mt-3">
										<div class="fam-lato fw-LM fs-12 color-3a3c40">
											Negative Mark
										</div>
										<template v-if="loading">
											<b-skeleton class="w-25 mt-1"></b-skeleton>
										</template>
										<div v-else class="fam-mont fw-M fs-14 color-3a3c40 pt-5px">
											{{ assessment.negativeMarks || "0" }}
										</div>
									</b-col>
									<b-col :cols="isLaptop ? null : 6">
										<div
											class="fam-lato fw-LM fs-12 color-3a3c40"
											:class="{
												'mt-3': !isLaptop,
											}"
										>
											Total attempts
										</div>
										<template v-if="loading">
											<b-skeleton class="w-25 mt-1"></b-skeleton>
										</template>
										<div v-else class="fam-mont fw-M fs-14 color-3a3c40 pt-5px">
											{{ assessment.config?.maxnoattempts || "N/A" }}
										</div>
									</b-col>
								</b-row>
							</article>
							<!-- Negative Mark & Buffer Time -->
							<article class="mt-3">
								<b-row>
									<b-col cols="4" id="hideinmobile">
										<div class="fam-lato fw-LM fs-12 color-3a3c40">
											Negative Mark
										</div>
										<template v-if="loading">
											<b-skeleton class="w-25 mt-1"></b-skeleton>
										</template>
										<div v-else class="fam-mont fw-M fs-14 color-3a3c40 pt-5px">
											{{ assessment.negativeMarks || "0" }}
										</div>
									</b-col>
									<b-col :cols="isLaptop ? 4 : 12">
										<div class="fam-lato fw-LM fs-12 color-3a3c40">
											Time between attempts
										</div>
										<template v-if="loading">
											<b-skeleton class="w-50 mt-1"></b-skeleton>
										</template>
										<div v-else class="fam-mont fw-M fs-14 color-3a3c40 pt-5px">
											{{ assessment.config?.timebnvalue || "N/A" }}
											{{ assessment.config?.timebnsel || "" }}
										</div>
									</b-col>
								</b-row>
							</article>
							<!-- Test Name & Description -->
							<article class="mt-3">
								<div class="fam-lato fw-LM fs-12 color-3a3c40">Test Name</div>
								<template v-if="loading">
									<b-skeleton class="w-75 mt-1"></b-skeleton>
									<b-skeleton class="w-100 mt-2"></b-skeleton>
								</template>
								<template v-else>
									<div class="fam-mont fw-M fs-14 color-3a3c40 pt-5px">
										{{ titleCase(assessment.testName) || "N/A" }}
									</div>
									<div
										class="font-mont fw-R fs-12 color-3a3c40 pt-5px"
										v-html="
											assessment.testDescription ||
											assessment.config?.testDesc ||
											''
										"
									></div>
								</template>
							</article>
							<hr style="border-top: 1px solid #c4c4c4; opacity: 30%" />
							<!-- New Mobile Icons Section (from isha-task) -->
							<article id="hideinlaptop" class="tdnew-cnt-container">
								<template v-if="showProctoring">
									<b-row>
										<b-col class="d-flex gap-1 align-items-baseline">
											<div>
												<img
													src="../assets/assessment/mobduration.svg"
													alt=""
												/>
											</div>
											<div>
												<div class="fam-lato fw-LM fs-12 color-3a3c40">
													Duration
												</div>
												<div class="font-mont fw-M fs-14 color-3a3c40">
													{{ assessment.config?.testDuration || "N/A" }} mins
												</div>
											</div>
										</b-col>
										<b-col class="d-flex gap-1 align-items-baseline">
											<div>
												<img
													src="../assets/assessment/mobproctoring.svg"
													alt=""
												/>
											</div>
											<div>
												<div class="fam-lato fw-LM fs-12 color-3a3c40">
													Proctoring
												</div>
												<div class="font-mont fw-M fs-14 color-3a3c40">
													{{ proctoringLabel || "N/A" }}
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row class="mt-3">
										<b-col class="d-flex gap-1 align-items-baseline">
											<div>
												<img
													src="../assets/assessment/mobtotquestions.svg"
													alt=""
												/>
											</div>
											<div>
												<div class="fam-lato fw-LM fs-12 color-3a3c40">
													Total Questions
												</div>
												<div class="font-mont fw-M fs-14 color-3a3c40">
													{{ totalQuestionsDisplay }}
												</div>
											</div>
										</b-col>
										<b-col class="d-flex gap-1 align-items-baseline">
											<div>
												<img
													src="../assets/assessment/mobtotsections.svg"
													alt=""
												/>
											</div>
											<div>
												<div class="fam-lato fw-LM fs-12 color-3a3c40">
													Total Sections
												</div>
												<div class="font-mont fw-M fs-14 color-3a3c40">
													{{ sections.length || 0 }}
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row class="mt-3">
										<b-col class="d-flex gap-1 align-items-baseline">
											<div>
												<img
													src="../assets/assessment/mobdifflevel.svg"
													alt=""
												/>
											</div>
											<div>
												<div class="fam-lato fw-LM fs-12 color-3a3c40">
													Difficulty Level
												</div>
												<div class="font-mont fw-M fs-14 color-3a3c40">
													{{ assessment.difficultyLevel || "N/A" }}
												</div>
											</div>
										</b-col>
									</b-row>
								</template>
								<template v-else>
									<b-row>
										<b-col cols="6" class="d-flex gap-1 align-items-baseline">
											<div>
												<img
													src="../assets/assessment/mobduration.svg"
													alt=""
												/>
											</div>
											<div>
												<div class="fam-lato fw-LM fs-12 color-3a3c40">
													Duration
												</div>
												<div class="font-mont fw-M fs-14 color-3a3c40">
													{{ assessment.config?.testDuration || "N/A" }} mins
												</div>
											</div>
										</b-col>
										<b-col cols="6" class="d-flex gap-1 align-items-baseline">
											<div>
												<img
													src="../assets/assessment/mobtotquestions.svg"
													alt=""
												/>
											</div>
											<div>
												<div class="fam-lato fw-LM fs-12 color-3a3c40">
													Total Questions
												</div>
												<div class="font-mont fw-M fs-14 color-3a3c40">
													{{ totalQuestionsDisplay }}
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row class="mt-3">
										<b-col cols="6" class="d-flex gap-1 align-items-baseline">
											<div>
												<img
													src="../assets/assessment/mobtotsections.svg"
													alt=""
												/>
											</div>
											<div>
												<div class="fam-lato fw-LM fs-12 color-3a3c40">
													Total Sections
												</div>
												<div class="font-mont fw-M fs-14 color-3a3c40">
													{{ sections.length || 0 }}
												</div>
											</div>
										</b-col>
										<b-col cols="6" class="d-flex gap-1 align-items-baseline">
											<div>
												<img
													src="../assets/assessment/mobdifflevel.svg"
													alt=""
												/>
											</div>
											<div>
												<div class="fam-lato fw-LM fs-12 color-3a3c40">
													Difficulty Level
												</div>
												<div class="font-mont fw-M fs-14 color-3a3c40">
													{{ assessment.difficultyLevel || "N/A" }}
												</div>
											</div>
										</b-col>
									</b-row>
								</template>
							</article>
							<article
								class="tdnew-cnt-container d-flex align-items-center position-relative mt-2"
								v-if="
									assessment.config?.communicationTest ||
									assessment.config?.typingTest
								"
								id="hideinlaptop"
							>
								<!-- SLIDER CONTENT -->
								<template
									v-if="
										sliderIndex === 0 && assessment.config?.communicationTest
									"
								>
									<div
										class="d-flex align-items-start"
										:style="{ width: isLaptop ? '48%' : '100%' }"
									>
										<img src="@/assets/img/Testdetails/communicationtest.svg" />
										<div class="w-100 ml-2">
											<div class="fam-mont fw-M fs-14 color-3a3c40">
												Communication Test
											</div>
											<div class="fs-12 fw-R fam-mont color-3a3c40 mt-1">
												Describe the picture in your own words using keywords
												given.
											</div>
										</div>
									</div>
								</template>

								<template
									v-if="sliderIndex === 1 && assessment.config?.typingTest"
								>
									<div
										class="d-flex align-items-start"
										:style="{ width: isLaptop ? '48%' : '100%' }"
									>
										<img src="@/assets/img/Testdetails/communicationtest.svg" />
										<div class="w-100 ml-2">
											<div class="fam-mont fw-M fs-14 color-3a3c40">
												Typing Test
											</div>
											<div class="fs-12 fw-R fam-mont color-3a3c40 mt-1">
												Take a typing test to measure your accuracy by typing
												the sentence.
											</div>
										</div>
									</div>
								</template>

								<!-- Slider dots -->
								<div class="slider-dots-container" id="hideinlaptop">
									<div class="slider-dots d-flex justify-content-center">
										<span
											v-for="(dot, index) in 2"
											:key="'dot-' + index"
											class="dot"
											:class="{ active: sliderIndex === index }"
											@click="setSlide(index)"
										></span>
									</div>
								</div>
							</article>
							<article
								v-if="
									assessment.config?.communicationTest ||
									assessment.config?.typingTest
								"
								id="hideinmobile"
								class="tdnew-cnt-container d-flex align-items-center position-relative"
							>
								<!-- SLIDER CONTENT -->
								<div
									class="d-flex align-items-start"
									v-if="assessment.config?.communicationTest"
								>
									<img src="@/assets/img/Testdetails/communicationtest.svg" />
									<div class="w-100 ml-2">
										<div class="fam-mont fw-M fs-14 color-3a3c40">
											Communication Test
										</div>
										<div class="fs-12 fw-R fam-mont color-3a3c40 mt-1">
											Describe the picture in your own words using keywords
											given.
										</div>
									</div>
								</div>

								<hr
									v-if="
										assessment.config?.communicationTest &&
										assessment.config?.typingTest
									"
									class="my-0"
									style="
										transform: rotate(90deg);
										width: 50px;
										border-top: 1px solid #c4c4c4;
										opacity: 30%;
									"
								/>
								<template v-if="assessment.config?.typingTest">
									<div
										class="d-flex align-items-start"
										:class="assessment.config?.communicationTest ? 'ml-3' : ''"
										:style="{ width: isLaptop ? '48%' : '100%' }"
									>
										<img
											src="@/assets/img/Testdetails/communicationtest.svg"
											alt=""
										/>
										<div class="w-100 ml-2">
											<div class="font-mont fw-M fs-14 color-3a3c40 text-break">
												Typing Test
											</div>
											<div class="fs-12 fw-R font-mont color-3a3c40 mt-1">
												Take a typing test to measure your accuracy by <br />
												typing the displayed sentence accurately.
											</div>
										</div>
									</div>
								</template>
							</article>
							<!-- Sections / Contents -->
							<template v-if="!loading && sections.length > 0">
								<div
									class="position-relative mt-4"
									:class="isLaptop ? 'mt-4' : 'mt-5'"
								>
									<hr style="border-top: 1px solid #ced1d4" class="my-3" />
									<div
										class="fam-lato fs-14 fw-M color-595959 mobbg-white px-2 position-absolute"
										style="
											left: 50%;
											top: -12px;
											transform: translateX(-50%);
											background: #eef3f7;
										"
									>
										Contents
									</div>
								</div>
								<div
									v-for="(section, index) in sections"
									:key="index"
									class="section-card"
									:class="index == 0 ? 'mt-0' : 'mt-3'"
								>
									<!-- Header -->
									<div
										class="d-flex justify-content-between align-items-center pointer p-12px"
										v-b-toggle="'section-' + index"
										@click="toggleSection(index)"
									>
										<div class="fw-LM fs-14 fam-lato text-black">
											{{
												titleCase(
													section.name ||
														section.sectionName ||
														"Section " + (index + 1)
												)
											}}
										</div>

										<div class="d-flex align-items-center">
											<span class="mr-2"
												><span class="fw-R fam-mont fs-12 color-3a3c40"
													><img
														src="@/assets/img/Testdetails/greytotquestions.svg"
														alt=""
														class="mr-1"
													/>Total Questions: </span
												><span class="fw-LM fam-mont fs-12 color-3a3c40">{{
													section.totalQuestions || 0
												}}</span>
											</span>
											<img
												class="ml-2"
												:class="{
													rotateArrow: activeSection !== index,
													rotateddown: activeSection === index,
												}"
												src="@/assets/img/Testdetails/uparrow.svg"
											/>
										</div>
									</div>

									<!-- Collapse -->
									<b-collapse
										:id="'section-' + index"
										accordion="section-accordion"
										class="section-accordion"
									>
										<div class="dashed-divider-td"></div>
										<div class="section-body p-12px">
											<div
												class="d-flex flex-wrap align-items-center"
												style="gap: 12px"
											>
												<div
													v-for="(level, lIdx) in section.difficultyBreakdown ||
													[]"
													:key="lIdx"
													v-if="level.questions > 0"
													class="d-flex align-items-center px-2 py-1"
													style="
														background: #f6f9fb;
														border-radius: 6px;
														border: 1px solid #efefef;
													"
												>
													<img
														src="@/assets/assessment/level.svg"
														alt=""
														class="mr-2"
														width="14"
													/>
													<span class="fs-12 fam-lato color-3a3c40">
														<span class="fw-R">{{ level.level }}:</span>
														<span class="fw-M ml-1">{{ level.questions }}</span>
													</span>
												</div>
											</div>
										</div>
									</b-collapse>
								</div>
							</template>
							<!-- Shimmer for sections -->
							<template v-if="loading">
								<div class="position-relative mt-4">
									<hr style="border-top: 1px solid #ced1d4" class="my-3" />
									<div
										class="fam-lato fs-14 fw-M color-595959 px-2 position-absolute"
										style="left: 40%; top: -12px; background: #eef3f7"
									>
										Contents
									</div>
								</div>
								<div
									v-for="n in 2"
									:key="'shimSec-' + n"
									class="section-card"
									:class="n === 1 ? 'mt-0' : 'mt-3'"
								>
									<div
										class="d-flex justify-content-between align-items-center p-12px"
									>
										<b-skeleton class="w-33"></b-skeleton>
										<b-skeleton class="w-25"></b-skeleton>
									</div>
								</div>
							</template>
							<div style="height: 20px"></div>
						</section>
						<!-- Right Side Panel -->
						<section
							id="hideinmobile"
							class="w-30 d-flex align-items-center ml-5 justify-content-center flex-column gap-3"
						>
							<article class="d-flex align-items-center gap-3">
								<!-- Duration -->
								<div
									:class="!showProctoring && 'width-340px'"
									class="tdnew-cnt-container h168w144 d-flex flex-column align-items-center justify-content-center"
								>
									<img src="../assets/img/Testdetails/duration.svg" alt="" />
									<div class="fw-LM fam-lato fs-12 color-3a3c40 mt-3">
										Duration
									</div>
									<template v-if="loading">
										<b-skeleton class="w-50 mt-1"></b-skeleton>
									</template>
									<div v-else class="fw-M fam-mont fs-12 color-3a3c40 pt-5px">
										{{ assessment.config?.testDuration || "N/A" }} mins
									</div>
								</div>
								<!-- Proctoring -->
								<div
									v-if="showProctoring"
									class="tdnew-cnt-container h168w144 d-flex flex-column align-items-center justify-content-center"
								>
									<img :src="proctoringImage" alt="" />
									<div class="fw-LM fam-lato fs-12 color-3a3c40 mt-3">
										Proctoring
									</div>
									<template v-if="loading">
										<b-skeleton class="w-50 mt-1"></b-skeleton>
									</template>
									<div v-else class="fw-M fam-mont fs-12 color-3a3c40 pt-5px">
										{{ proctoringLabel }}
										<img
											src="../assets/img/Testdetails/noteicon.svg"
											class="ml-1"
											alt=""
											v-b-tooltip.hover="proctoringInfoText"
										/>
									</div>
								</div>
							</article>
							<article
								class="h143w346 tdnew-cnt-container d-flex justify-content-between align-items-center"
							>
								<!-- Total Questions -->
								<div
									class="d-flex flex-column align-items-center justify-content-center"
								>
									<img
										src="../assets/img/Testdetails/totquestions.svg"
										alt=""
									/>
									<div class="fw-LM fam-lato fs-12 color-3a3c40">
										Total Questions
									</div>
									<template v-if="loading">
										<b-skeleton class="w-50 mt-1"></b-skeleton>
									</template>
									<div v-else class="fw-M font-mont fs-12 color-3a3c40 pt-5px">
										{{ totalQuestionsDisplay }}
									</div>
								</div>
								<!-- Total Sections -->
								<div
									class="d-flex flex-column align-items-center justify-content-center"
								>
									<img src="../assets/img/Testdetails/totsections.svg" alt="" />
									<div class="fw-LM fam-lato fs-12 color-3a3c40">
										Total Sections
									</div>
									<template v-if="loading">
										<b-skeleton class="w-50 mt-1"></b-skeleton>
									</template>
									<div v-else class="fw-M fam-mont fs-12 color-3a3c40 pt-5px">
										{{ sections.length || "N/A" }}
									</div>
								</div>
								<!-- Difficulty Level -->
								<div
									class="d-flex flex-column align-items-center justify-content-center"
								>
									<img
										src="../assets/img/Testdetails/bluedifflevel.svg"
										alt=""
									/>
									<div class="fw-LM fam-lato fs-12 color-3a3c40">
										Difficulty Level
									</div>
									<template v-if="loading">
										<b-skeleton class="w-50 mt-1"></b-skeleton>
									</template>
									<div v-else class="fw-M fam-mont fs-12 color-3a3c40 pt-5px">
										{{ assessment.difficultyLevel }}
									</div>
								</div>
							</article>
						</section>
					</section>
					<hr
						style="border-top: 1px solid #c4c4c4; opacity: 30%"
						id="hideinmobile"
					/>

					<div
						class="d-flex align-items-center justify-content-end w-100"
						id="hideinmobile"
					>
						<b-button class="candash-addBtn" v-if="!loading">
							<template
								v-if="!testPricing.isFree && !assessment.pricing_info.purchased"
							>
								<span @click="purchaseTest(assessment)">
									₹{{ testPricing.finalPrice }}
									<span
										v-if="testPricing.hasDiscount"
										class="text-strike-price fam-mont ml-1"
									>
										₹{{ testPricing.listPrice }}
									</span>
									<span class="mx-1">
										<img src="@/assets/icons/line.svg" alt="" />
									</span>
									Buy Now
								</span>
							</template>
							<template v-else
								><span @click="takeNewTest(assessment)">
									Take Test
								</span></template
							>
						</b-button>
					</div>
				</section>
				<div
					class="mob-td-footer"
					id="hideinlaptop"
					:class="{
						'bottom-0': hasAccess(),
					}"
				>
					<b-button class="candash-addBtn w-100" v-if="!loading">
						<template
							v-if="!testPricing.isFree && !assessment.pricing_info.purchased"
						>
							<span @click="purchaseTest(assessment)">
								₹{{ testPricing.finalPrice }}
								<span
									v-if="testPricing.hasDiscount"
									class="text-strike-price fam-mont ml-1"
								>
									₹{{ testPricing.listPrice }}
								</span>
								<span class="mx-1">
									<img src="@/assets/icons/line.svg" alt="" />
								</span>
								Buy Now
							</span>
						</template>
						<template v-else>
							<span @click="takeNewTest(assessment)">Take Test</span>
						</template>
					</b-button>
				</div>
			</template>
		</template>
		<div style="display: none" ref="responseContainer"></div>
	</main>
</template>

<script>
import { hasAccess } from "@/utils/tokenCheck";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import {
	getParticularPublicTest,
	getGlobalTrending,
	postPurchaseTest,
} from "@/utils/apiFunctions";
import { mapGetters } from "vuex";
import EventBus from "@/utils/EventBus";
import payment from "../components/mixin/payment.js";
import toast from "../components/mixin/toast.js";
import Spinner from "@/components/fixedcomponents/Spinner.vue";

export default {
	components: {
		NcdTopContainer,
		Spinner,
	},
	mixins: [payment, toast],
	data() {
		return {
			loading: true,
			assessment: {},
			sections: [],
			activeSection: null,
			isLaptop: true,
			sliderIndex: 0,
			sliderTimer: null,
			loaderStatus: false,
			purchasedTest: false,
		};
	},

	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		paymentItemID() {
			return this.assessment?.pricing_info.paymentItemID;
		},
		proctoringLabel() {
			const config = this.assessment.config;
			if (!config) return "N/A";
			if (
				config.enableProctoring ||
				config.allowAgent ||
				config.allowExtension
			) {
				return "Enabled";
			}
			return "Disabled";
		},
		showProctoring() {
			const config = this.assessment.config;
			if (!config) return false;
			return !!(
				config.enableProctoring ||
				config.allowAgent ||
				config.allowExtension
			);
		},
		proctoringImage() {
			const config = this.assessment.config;
			if (!config)
				return require("@/assets/img/Testdetails/threeextension.svg");

			const agent = config.allowAgent;
			const ext = config.allowExtension;
			const video = config.enableProctoring;

			if (agent && ext && video) {
				return require("@/assets/newdesign/assessPro/allProctoring.svg");
			} else if (agent && ext) {
				return require("@/assets/newdesign/assessPro/extensionAndAgent.svg");
			} else if (ext && video) {
				return require("@/assets/newdesign/assessPro/extensionAndVideo.svg");
			} else if (video && agent) {
				return require("@/assets/newdesign/assessPro/agentAndVideo.svg");
			} else if (agent) {
				return require("@/assets/newdesign/assessPro/agent.svg");
			} else if (ext) {
				return require("@/assets/newdesign/assessPro/extension.svg");
			} else if (video) {
				return require("@/assets/newdesign/assessPro/video.svg");
			}
			return require("@/assets/img/Testdetails/threeextension.svg");
		},
		proctoringInfoText() {
			const config = this.assessment.config;
			if (!config) return "No proctoring information available.";
			let details = [];
			if (config.allowAgent) details.push("Agent Proctoring");
			if (config.allowExtension) details.push("Extension Proctoring");
			if (config.enableProctoring) details.push("Video Proctoring");

			if (details.length === 0) return "No proctoring enabled for this test.";
			return details.join(", ");
		},
		testOrganizerDisplay() {
			const config = this.assessment.config;
			return (
				this.assessment.testOrg ||
				this.assessment.organiser ||
				config?.testOrg ||
				config?.organiser ||
				this.assessment.customerName ||
				this.assessment.companyName ||
				this.assessment.organiserName ||
				this.assessment.customFields?.Board_Organization ||
				this.assessment.orgName ||
				this.assessment.clientName ||
				"N/A"
			);
		},
		testPricing() {
			const pricing = this.assessment.pricing_info;
			const listPrice = pricing?.listPrice || 0;
			const finalPrice = pricing?.finalPrice || 0;
			const discountAmount = pricing?.discountAmount || 0;

			return {
				listPrice,
				finalPrice,
				discountAmount,
				isFree: finalPrice <= 0,
				hasDiscount: listPrice > finalPrice && discountAmount > 0,
			};
		},
		totalQuestionsDisplay() {
			return (
				this.assessment.totalQuestions ||
				this.assessment.totalQuestionsCount ||
				0
			);
		},
	},
	async created() {
		this.createdActions();
		EventBus.$on("login-success", this.createdActions);
		EventBus.$on("onboarding-fetch-post-login", this.createdActions);
	},
	beforeDestroy() {
		EventBus.$off("login-success", this.createdActions);
		EventBus.$off("onboarding-fetch-post-login", this.createdActions);
	},
	watch: {
		"$route.query": {
			async handler(newVal) {
				if (newVal.testID) {
					await this.fetchTestDetails(newVal.testID);
				}
			},
			deep: true,
		},
	},
	methods: {
		purchaseTest(assessment) {
			if (!hasAccess()) {
				EventBus.$emit("open-login-modal");
				return;
			}
			this.loaderStatus = true;
			this.checkCustomer();
		},
		async postPurchaseTest() {
			console.log("called post purchase", this.orderID);

			if (!this.orderID) return;
			try {
				let payload = {
					references: [this.assessment.testID],
					orderID: this.orderID,
					email: this.userInfo.email,
					pricingID: this.assessment.pricing_info.pricingID,
				};

				const response = await postPurchaseTest(payload);
				console.log("Purchase Test Response:", response);
				// this.$emit("refreshPublicTests");
				this.assessment.pricing_info.purchased = true;
				this.loaderStatus = false;
				this.successModal("Success", "Test purchased successfully!");
				this.$emit("purchase-success");
			} catch (error) {
				console.error("Error purchasing test:", error);
			} finally {
				this.loaderStatus = false;
			}
		},
		takeNewTest(assessment) {
			if (!hasAccess()) {
				EventBus.$emit("open-login-modal");
				return;
			}
			// Construct query parameters for the redirect page
			const query = {
				testID: assessment.testID,
				publicConfigType: assessment.publicConfigType || 0,
				isPublic: assessment.isPublic,
			};

			if (!assessment.isPublic && assessment.shareLinkWithQuery) {
				query.shareLink = assessment.shareLinkWithQuery;
			}

			// Create the local URL for the redirect page
			const routeData = this.$router.resolve({
				name: "AssessmentRedirect",
				query: query,
			});

			// Open the redirect page in a new tab synchronously
			window.open(routeData.href, "_blank");
		},
		openLoginModal() {
			EventBus.$emit("open-login-modal");
		},
		hasAccess() {
			return hasAccess();
		},
		startSlider() {
			this.sliderTimer = setInterval(() => {
				this.nextSlide();
			}, 5000);
		},
		stopSlider() {
			if (this.sliderTimer) {
				clearInterval(this.sliderTimer);
			}
		},
		nextSlide() {
			this.sliderIndex = (this.sliderIndex + 1) % 2;
		},
		setSlide(index) {
			this.sliderIndex = index;
			this.stopSlider();
			this.startSlider();
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		async createdActions() {
			const testID = this.$route.query.testID;
			if (testID) {
				await this.fetchTestDetails(testID);
				this.getTrendingAssessment(testID);
			} else {
				this.loading = false;
			}
		},
		async fetchTestDetails(testID) {
			this.loading = true;
			try {
				const payload = {
					testID,
					email: this.userInfo.email,
				};
				const res = await getParticularPublicTest(payload);
				if (res.status === 200) {
					const found = res.data.data;

					if (found) {
						this.assessment = found;
						this.sections = found.sections || [];
					} else {
						console.warn("Test not found in public list:", testID);
					}
				}
			} catch (error) {
				console.error("Error fetching test details:", error);
			} finally {
				this.loading = false;
			}
		},

		toggleSection(index) {
			this.activeSection = this.activeSection === index ? null : index;
		},
		formatDate(date) {
			if (!date) return "N/A";
			return new Date(date)
				.toLocaleString("en-IN", {
					day: "2-digit",
					month: "2-digit",
					year: "numeric",
				})
				.replaceAll("/", "-");
		},
		formatTime(date) {
			if (!date) return "";
			return new Date(date).toLocaleString("en-IN", {
				hour: "numeric",
				minute: "numeric",
				hour12: true,
			});
		},
		titleCase(str) {
			if (!str && str !== 0) return "";
			const s = String(str).toLowerCase();
			return s.replace(/\b([a-z])/g, (m, p) => p.toUpperCase());
		},
		async getTrendingAssessment(testID) {
			try {
				let payload = {
					type: "assessment",
					interactionType: "click",
					referenceID: testID || this.assessment.testID,
				};
				const response = await getGlobalTrending(payload);
			} catch (error) {
				console.log(error);
			}
		},
	},
};
</script>

<style>
.td-main-container {
	height: calc(100vh - 72px);
	top: 72px;
	overflow: hidden;
	padding: 20px 20px 20px 80px;
}
.td-main-whitecontainer {
	background: #ffffff;
	box-shadow: 0px 15px 30px rgba(122, 122, 122, 0.2);
	border-radius: 14px;
	padding: 20px;
}
.td-main-bluecontainer {
	background: rgba(32, 99, 155, 0.08);
	border-radius: 14px;
	padding: 30px 80px 30px 90px;
	overflow-y: auto;
	overflow-x: hidden;
}
.pt-5px {
	padding-top: 5px;
}
.tdnew-cnt-container {
	background: linear-gradient(0deg, #ffffff, #ffffff), rgba(32, 99, 155, 0.08);
	border-radius: 14px;
	padding: 15px;
}

.section-card {
	background: #ffffff;
	border: 1px solid #efefef;
	border-radius: 8px;
	overflow: hidden;
}
.p-12px {
	padding: 12px;
}
.section-accordion {
	background: #f6f9fb;
}
.dashed-divider-td {
	width: 100%;
	height: 1px;
	background-image: repeating-linear-gradient(
		to right,
		#d1d5db 0px,
		#d1d5db 8px,
		transparent 8px,
		transparent 10px
	);
}
.rotateArrow {
	transform: rotate(180deg);
	transition: transform 0.3s ease;
}
.rotateddown {
	transform: rotate(0);
}
.h168w144 {
	height: 168px;
	width: 144px;
}
.h143w346 {
	height: 143px;
	width: 346px;
}
.bg-e9ecef {
	background: #e9ecef;
}
@media (max-width: 1028px) {
	.td-main-container {
		height: 100dvh;
		position: unset !important;
		padding: 0;
	}
	.td-main-bluecontainer {
		all: unset;
	}
	.td-main-whitecontainer {
		border-radius: 0;
		margin: 10px;
		width: 95% !important;
		border-radius: 8px;
		overflow: auto;
		height: calc(100dvh - 240px) !important;
		top: 22px;
		position: relative;
	}
	.top75 {
		top: 75px;
	}
	.td-main-whitecontainer-loggedin {
		height: calc(100dvh - 150px) !important;
		top: 0;
	}
	.mob-d-block {
		display: block !important;
	}
	.pt-5px {
		padding-top: 0;
	}
	.mobbg-white {
		background: #ffffff !important;
	}
	.tdnew-cnt-container {
		background: #f6f9fb;
		border-radius: 8px;
	}
	.h20w30 {
		height: 20px;
		width: 30px;
	}
	.mobml-0 {
		margin-left: 0 !important;
	}
	.mob-d-block {
		display: block !important;
	}
	.mobgap-0 {
		gap: 0 !important;
	}
	.mob-td-footer {
		padding: 16px;
		gap: 10px;
		position: absolute;
		width: 100%;
		height: 68px;
		left: 0px;
		bottom: 82px;
		background: #ffffff;
	}
}
.text-strike-price {
	font-weight: 400;
	font-size: 12px;
	text-decoration-line: line-through;
	color: #e0e0e0;
}

.slider-dots-container {
	z-index: 10;
	padding-bottom: 25px;
	position: absolute;
	width: 100%;
	bottom: -45px;
	left: 0;
}

.dot {
	width: 10px;
	height: 10px;
	background-color: #d9d9d9;
	border-radius: 50%;
	margin: 0 4px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.dot.active {
	background-color: #20639b;
	width: 12px;
	height: 12px;
}
.td-main-container-loggedin {
	height: calc(100vh - 60px);
	top: 60px;
}
.padding20px {
	padding: 20px 20px 20px 20px;
}
</style>
